/* eslint-disable no-prototype-builtins */
var XPortal = XPortal || {};
XPortal.Store = (function () {
    var self = {
        debug: false, relatedDataSources: [], SaveIntervalMs: 200, middleWares: [], apiBaseUrl: "/api/2.0/Entities/Data/", itemsInSaving: 0, isDispatching: false
    };
    var selfData = { eventsInProgress: [], eventStateHandlers: [] };
    self.GetState = function (reduserName) {
        if (!self.AppStore) XPortal.Store.Init();
        var xstate = self.AppStore.getState();
        if (!reduserName) return xstate.baseReduser;
        if (xstate.hasOwnProperty(reduserName))
            return xstate[reduserName];
        return null;
    };
    self.GetBaseReduserState = function () {
        return self.AppStore.getState().baseReduser;
    };
    self.IsDispatching = function () {
        return self.isDispatching === true;
    };
    self.AddMiddleWare = function (middleWareHandler) {
        self.middleWares.push(middleWareHandler);
    };
    self.GetModelByNodeId = function (id) {
        var models = self.GetBaseReduserState().pageModels;
        for (var key in models) {
            var matches = key.match(/(\d+)/);
            if (matches && matches[0] == id)
                return key;
        }
    };
    self.GetModelByName = function (name, pageModels) {
        if (name == null || name.length < 1) return null;
        var models = pageModels || self.GetBaseReduserState().pageModels;
        for (var key in models) {
            if (key === name) return models[key];
        }
        return null;
    };
    self.GetModelPath = function (container, cmodelName) {
        const state = XPortal.Store.GetState();
        let existing = [];
        for (var modelName in state.pageModels) {
            const selector = state.pageModels[modelName].model.selector;
            if (selector && modelName != cmodelName) {
                let level = 0;
                let citem = $(selector);
                do { level++; } while ((citem = citem.parent()) != null && citem.length);

                if (container.closest(selector).length)
                    existing.push({ modelName, selector, level });
            }
        }
        existing = _.sortBy(existing, ix => ix.length).reverse();
        return existing.map(ix => ix.modelName).join(">>") + ">>" + cmodelName;
    };
    self.GetParentModelName = function (modelName, modelPath) {
        if (!modelName) return null;
        const model = self.GetModelByName(modelName);
        modelPath = modelPath || ((model || {}).model || {}).modelPath;
        if (!modelPath || modelPath.length < 1) return null;
        const pathParts = modelPath.split(">>");
        let i = 0;
        while (pathParts[i] != modelName && i < pathParts.length) i++;
        if (i < 1 || i >= pathParts.length) return null;

        return pathParts[i - 1];
    };
    self.GetParentModel = function (model, pageModels) {
        if (!model || !model.model.modelPath) return null;
        const pathParts = model.model.modelPath.split(">>");
        let i = 0;
        while (pathParts[i] != model.model.modelName && i < pathParts.length) i++;
        if (i < 1 || i >= pathParts.length) return null;

        return self.GetModelByName(pathParts[i - 1], pageModels);
    };
    self.HasInProgressEvents = function (filter) {
        if (filter) return filter(selfData.eventsInProgress);
        return selfData.eventsInProgress.length > 0;
    };
    self.getModelName = function (selector) {
        if (selector && selector.indexOf && selector.indexOf("_") > 0) return selector;
        return _getModelName(selector, "PM.");
    };
    self.getGridModelName = function (selector) {
        return _getModelName(selector, "GM.");
    };
    function _getModelName(selector, prefix) {
        if (selector instanceof jQuery && selector.length > 0)
            selector = selector[0].id;
        if (selector.startsWith("GM.") || selector.startsWith("PM.")) return selector;
        return prefix + selector.replace(/[#|&;$%@"<>()+,]/g, "");
    }
    self.SetItemToSave = function (model, entity, nodeId, updateGrid) {
        if (model.model.skipSaving) return;
        var itemsToSave = model.itemsToSave || [];
        ind = itemsToSave.findIndex(i => i.entity.UniqueId === entity.UniqueId);
        if (ind > -1) {
            itemsToSave[ind].added = new Date();
            itemsToSave[ind].inUse = false;
            itemsToSave[ind].entity = entity;
        }
        else if (nodeId) //only for EDIT_FIELD
            itemsToSave.push({ inUse: false, added: new Date(), entity: entity, nodeId: nodeId, updateGrid: updateGrid });
        //update model status
        model.itemsToSave = itemsToSave;
        self.UpdateStatus(model);
    };
    self.ClearItemToSave = function (model, itemToRemove = null) {
        if (itemToRemove && model.itemsToSave && model.itemsToSave.length > 0) {
            var itemIndex = model.itemsToSave.findIndex((item) => item.entity.UniqueId === itemToRemove.UniqueId);
            if (itemIndex !== -1) {
                model.itemsToSave.splice(itemIndex, 1);
            }
        }
        else {
            model.itemsToSave = [];
        }

        self.UpdateStatus(model);
        self.RecalculateIsChanged();
    };
    self.RecalculateIsChanged = function () {
        var state = self.GetBaseReduserState();
        if (state.editParameters) {
            state.editParameters.IsChanged = XPortal.Store.IsEntityToSavePresent(state);
        }
    };
    self.UpdateStatus = function (model, wasSaved) {
        if (!model.EntityState) {
            model.EntityState = {};
        }
        if (model.SaveInProgress) {
            model.EntityState.Key = "saveinprocess";
            return;
        }
        if (wasSaved) {
            model.EntityState.Key = "saved";
            return;
        }
        var itemsToSave = model.itemsToSave || [];
        if (itemsToSave.length === 0) {
            model.EntityState.Key = "nochanges";
        } else {
            if (itemsToSave.length === 1) {
                model.EntityState.Key = "notsaved";
            } else if (itemsToSave.length > 1) {
                model.EntityState.Key = "savenumber";
                model.EntityState.Data = { ItemsToSave: itemsToSave.length };
            }
        }
    };
    self.getInLineItemsToSave = function (doNotCheckTime, parentModelName, onlyForAutoSave) {
        var state = self.GetBaseReduserState();
        var objToSave = [];
        var nowTimestamp = new Date();
        for (var key in state.pageModels)
            if (key.startsWith("GM.")) {
                const imodel = state.pageModels[key];
                if (!parentModelName || imodel.model.modelPath.indexOf(parentModelName) >= 0) {
                    if (imodel.itemsToSave) {
                        if (onlyForAutoSave && isAutoSaveEnabled(imodel) == false) continue;
                        // autosave only records, that are not being edited right now
                        var editingUid = getEditingCellRowUid(key);
                        var objToSaveInd = state.pageModels[key].itemsToSave.filter(i => !i.inUse
                            && !isEntityBeingEdited(i, editingUid)
                            && (doNotCheckTime || nowTimestamp - i.added > self.SaveIntervalMs));
                        var modelObjToSave = objToSaveInd.map(function (o) { o.selector = key; return o; });
                        if (modelObjToSave.length > 0) objToSave = objToSave.concat(modelObjToSave);
                    }
                }
            }
        return objToSave;
    };
    function isAutoSaveEnabled(imodel) {
        const autosaveTimeOut = Number(imodel.model.autoSaverTimeOut);
        return !isNaN(autosaveTimeOut) && autosaveTimeOut > 0;
    }
    self.IsEntityToSavePresent = function (state, pattern, onitems) {
        if (!state) state = self.GetState();
        var ritems = onitems ? [] : false;
        var result = false;
        for (key in state.pageModels) { //process only page models
            if (!pattern || (pattern && key.indexOf(pattern) === 0)) {
                if (state.pageModels[key].hasOwnProperty("itemsToSave")) {
                    var items = state.pageModels[key].itemsToSave.filter(e => !e.inUse);
                    if (items.length > 0) result = ritems ? ritems.push({ key, items }) : true;
                }
            }
        }
        return onitems && ritems.length > 0 ? onitems(ritems) : result;
    };
    // models with pending changes that autosave will never pick up (autosave is turned off)
    self.GetManualSaveModelNames = function () {
        const state = self.GetBaseReduserState();
        return Object.keys(state.pageModels).filter(key => {
            const imodel = state.pageModels[key];
            return imodel.itemsToSave && imodel.itemsToSave.some(i => !i.inUse) && !isAutoSaveEnabled(imodel);
        });
    };
    self.WaitForAllModelsSaveDone = function (timeoutMs = 500, timeoutIterationsCount = 20) {
        return new Promise((onOk, onErr) => {
            let attempts = 0;
            XPortal.Utils.waitFor(() => {
                attempts++;
                if (attempts == 1 || self.IsEntityToSavePresent() || self.itemsInSaving > 0)
                    return false;
                if (attempts == 2) {
                    onOk();
                    return true;
                } else {
                    attempts = 0;
                }

            }, XPortal.Utils.waitFor, timeoutMs, timeoutIterationsCount, onErr);
        });
    };
    self.getTopModelNameToSave = function (state) {
        if (!state) state = self.GetState();
        var ritems = [];

        for (key in state.pageModels) { //process only page models

            if (state.pageModels[key].hasOwnProperty("itemsToSave")) {
                var items = state.pageModels[key].itemsToSave.filter(e => !e.inUse);
                if (items.length > 0) ritems.push(key);
            }

        }
        var pItem = ritems.find(x => x.toLowerCase().indexOf("pm.") > -1);
        if (pItem) return pItem;
        if (ritems.length) return ritems.pop();
        return null;
    };

    self.IsInlineEntityToSavePresent = function () {
        var r = self.IsEntityToSavePresent(self.GetState(), "GM.");
        return r;
    };
    self.GetEditEntityToSave = function (flush) {
        var state = self.GetBaseReduserState();
        var entityList = [];
        for (var key in state.pageModels) {
            if (key.startsWith("PM.") && state.pageModels.hasOwnProperty(key))
                self.GetModelEntityToSave(flush, state.pageModels[key]).forEach(x => entityList.push(x));
        }
        return entityList;
    };
    self.GetModelEntityToSave = function (flush, model) {
        const entityList = [];
        if (model.itemsToSave)
            model.itemsToSave.forEach(function (saveItem) {
                saveItem.inUse = flush ? false : true;
                var modelEntity = saveItem.entity;
                //create new object just to remove additional mapped properties
                var entityToSave = self.ConvertEditEntityToSave(modelEntity, model.model.ParentInfo);
                entityList.push(entityToSave);
            });
        return entityList;
    };
    self.ConvertEditEntityToSave = function (modelEntity, parentInfo) {
        var r = {
            Keys: modelEntity.Keys || [],
            Fields: modelEntity.Fields.map(function (f) {
                return {
                    "Field": f.Name,
                    "Data": Array.isArray(f.StringValue) ? f.StringValue.join(XPortal.GridInlineEditing.ValueSeparator) : f.StringValue,
                    "Ftype": f.ftype || f.Type
                };
            }),
            UniqueId: modelEntity.UniqueId,
            NodeId: modelEntity.NodeId,
            EntityAlias: modelEntity.EntityAlias,
            IsCreating: modelEntity.IsCreating
        };
        if (parentInfo) r.parentInfo = parentInfo;
        return r;
    };
    self.ConvertSavedEntityToEdit = function (entity) {
        if (!entity) return entity;
        entity.Fields.forEach(function (f) {
            var fname = XPortal.Template.GetObjPropName(f, "Name");
            var fdata = XPortal.Template.GetObjPropName(f, "StringValue");
            if (!f[fname]) f[fname] = f[XPortal.Template.GetObjPropName(f, "field")];
            if (!f[fdata]) f[fdata] = f[XPortal.Template.GetObjPropName(f, "data")];
        });
        return entity;
    };

    self.SaveInlineItemsRefresh = function (doNotCheckTime, markNotValid, parenModelName) {
        var itemToSave = self.getInLineItemsToSave(doNotCheckTime, parenModelName);
        itemToSave.forEach(item => item.inUse = true);
        itemToSave = XPortal.GridInlineEditing.ValidateInlineEditors(itemToSave, markNotValid);
        if (itemToSave && itemToSave.length > 0)
            self.AppStore.dispatch(self.asyncSaveInlineItems(itemToSave)());
    };
    // store items and not update state (when form will be closed)
    self.SaveStoreItemsDefer = function (doNotCheckTime, silentMode, parenModelName, onlyForAutoSave) {
        return new Promise((onOk, onError) => {
            var itemToSave = self.getInLineItemsToSave(doNotCheckTime, parenModelName, onlyForAutoSave);
            itemToSave.forEach((item) => item.inUse = true);
            itemToSave = XPortal.GridInlineEditing.ValidateInlineEditors(itemToSave, false);
            if (itemToSave && itemToSave.length > 0) {
                var defs = [];
                itemToSave.forEach(function (item) {
                    var def = XPortal.GridInlineEditing.SaveEntity(item.entity, item.nodeId, silentMode);
                    if (!silentMode)
                        def.then(function (data) {
                            XPortal.EditForm.ShowServerErrorMessages([data.result]);
                        });
                    defs.push(def);
                });
                XPortal.GridInlineEditing.StartSaveQueue(defs, false)
                    .then(function (results) {
                        (results || []).forEach(function (r, ind) {
                            var data = r.resolved ? r.resolved[0] : null;
                            var failed = !!r.rejected || (data && XPortal.GridInlineEditing.IsFailedSaveResult(data.result));
                            if (failed && itemToSave[ind]) itemToSave[ind].inUse = false;
                        });
                        self.RecalculateIsChanged();
                        onOk(results);
                    }, onError);
            }
            else onOk();
        });
    };

    self.ValidateGridModel = function (modelName, markNotValid = true, skipFilterByInUse = false, showValMessages = false) {
        if (!modelName) {
            console.warn("Model name is null or empty during 'ValidateGridModel' call.");
            return false;
        }

        var state = self.GetBaseReduserState();
        if (!modelName.startsWith("GM.") || !state.pageModels.hasOwnProperty(modelName)) {
            return true;
        }

        var itemToSave = [];
        const pageItemsToSave = state.pageModels[modelName].itemsToSave;
        if (pageItemsToSave && pageItemsToSave.length) {
            var objToSaveInd = skipFilterByInUse ? pageItemsToSave : pageItemsToSave.filter(i => !i.inUse);
            itemToSave = itemToSave.concat(objToSaveInd);
        }

        if (!itemToSave || itemToSave.length === 0) {
            return true;
        }
        var validatedItemsToSave = XPortal.GridInlineEditing.ValidateInlineEditors(itemToSave, markNotValid, showValMessages);
        return itemToSave.length === validatedItemsToSave.length;
    };

    self.asyncSaveInlineItems = function (objToSave, onOk, onError) {
        const iresults = [];
        return () => (dispatch) => {
            const modelName = objToSave[0].selector;
            dispatch({ type: XPortal.Redusers.ACTIONS.SAVE_START, modelName });
            if (self.GetModelByName(modelName).model.readOnly) {
                dispatch({ type: XPortal.Redusers.ACTIONS.SAVE_END, modelName, saved: false });
                if (onOk) onOk(0);
            } else {
                const waitItems = [];
                let errorsAmount = 0;
                objToSave.forEach(function (obj) {
                    var waitForSave = XPortal.GridInlineEditing.SaveEntity(obj.entity, obj.nodeId).then(
                        (data) => {
                            const resArray = ((data || { result: { Result: [] } }).result || {}).Result;
                            const saveResult = !resArray.length ? [{ UniqueId: obj.entity.uniqueid, Fields: [] }] : resArray;
                            iresults.push(data.result);
                            if (saveResult && data.result.State >= 0)
                                dispatch({ type: XPortal.Redusers.ACTIONS.ITEM_SAVE_SUCCESS, modelName, selector: obj.selector, entity: obj.entity, saveResult: saveResult[0], updateGrid: obj.updateGrid });
                        },
                        error => {
                            errorsAmount++;
                            dispatch({ type: XPortal.Redusers.ACTIONS.ITEM_SAVE_FAIL, modelName, entity: obj.entity, error });
                        }
                    );
                    waitItems.push(waitForSave);
                });

                Promise.all(waitItems).then((results) => {
                    if (errorsAmount > 0) { if (onError) onError(errorsAmount); }
                    else { if (onOk) onOk(objToSave.length, iresults); }
                    XPortal.EditForm.ShowServerErrorMessages(iresults);
                    dispatch({ type: XPortal.Redusers.ACTIONS.SAVE_END, modelName, saved: false });
                });
            }
        };
    };


    self.MiddlewareWrapper = function (entityType, modelId, relatedData, userFunction, eventName) {
        //Our checks and injection
        return function UserCodeWhapper({ dispatch, getState }) {
            return function (next) {
                return function (action) {
                    var icontext = {
                        HandlerModelId: modelId,
                        HandlerEntityType: entityType,
                        RelatedData: relatedData,
                        EventName: eventName,
                        getState, dispatch,
                        finalized: null,//when enent contains code that working async - event should assign promise here- and should resolve it in the end of process
                    };
                    return XPortal.Events.EnsureMidlewareActionContext(next, action, icontext, function (context, entity) {
                        if (context.HandlerModelName !== action.model) //warn(uniqueEventCode + ' event is working only for model:' + context.HandlerModelName, -1, { amodel: action.model });
                            return next(action);
                        let wrapper = userFunction.bind(context, action, entity, context, next);
                        const entityId = entity ? entity.UniqueId : null;
                        action.preventDefault = false;
                        try {
                            if (action.omitEvents) {
                                //const f = action && action.field ? ""+action.field.field + "=" + action.field.data : "----";
                                //context.warn("skip events execution for:" + f + "| -" + modelId, -1, { a: action, m: modelId, e: entityType, });                                
                            } else {
                                //if (console) console.log("event for:", action, modelId, entityType, context, entity);
                                var eventid = context.EventName + '_' + entityId + "_" + Date.now();
                                self.StartEventProcessing(eventid, entityId, action.type, action);
                                wrapper().finally(function () {
                                    if (context.finalized == null)
                                        self.FinishEventProcessing(eventid, entityId, action.type, action);
                                    else//for async events - we have to wait for completelly finished state 
                                        context.finalized.finally(function () {
                                            self.FinishEventProcessing(eventid, entityId, action.type, action);
                                        });
                                });
                            }
                        }
                        catch (e) {
                            context.warn("event code fails:" + eventName, 1, action, entity, "for: ", modelId, entityType, context, entity);
                        }
                        if (!action.preventDefault) return next(action);
                    });
                };
            };
        };
    };
    //middlewares
    self.logger = function ({ dispatch, getState }) {
        return next => action => {
            if (self.debug && console && console.log) console.log('will dispatch', action);
            const returnValue = next(action);
            if (self.debug && console && console.log) console.log('state after dispatch', getState());
            return returnValue;
        };
    };
    self.autoSaver = function ({ dispatch, getState }) {
        return next => action => {
            if (action.type !== "AUTO_SAVE") {
                if (action.type !== XPortal.Redusers.ACTIONS.EDIT_FIELD || action.omitAutoSave) return next(action);
            }
            var before = self.GetState().pageModels[action.model].entity[action.field.field];
            const returnValue = next(action);
            var after = self.GetState().pageModels[action.model].entity[action.field.field];
            XPortal.EditForm.ValidateModel(action.model, true).then(function () {
                //validate form silently and start only in case when it valid
                self.TriggerAutoSave(action.model, before, after);
            });
            return returnValue;
        };
    };
    self.applyRules = function ({ dispatch, getState }) {
        return next => action => {
            const { LOADED_ENTITY, GRID_DATALOADED } = XPortal.Redusers.ACTIONS;

            if (action.type !== LOADED_ENTITY && action.type !== GRID_DATALOADED)
                return next(action);

            var model = XPortal.Store.GetModelByName(action.model);

            if (action.type === LOADED_ENTITY) {
                XPortal.SectionDisplayRules.hideAllSections(model);
            }

            let returnValue;
            try {
                returnValue = next(action);
            } catch (e) {
                if (console && console.log) {
                    console.log("An error occurred during applying rules.", { e });
                }
            }

            if (action.type === LOADED_ENTITY) {
                XPortal.SectionDisplayRules.initModel(model, action);
            }
            if (action.type === LOADED_ENTITY || action.type === GRID_DATALOADED) {
                if (model) // in popups, page models are overriden, but original page models could be dispatched, so we need to check it and do not trigger autofill in this case
                    XPortal.AutofillFields.initModel(model, action);
            }

            return returnValue || next(action);
        };
    };

    self.TriggerAutoSave = function (actionmodel, before, after) {
        self.autoSaverTimeOut = self.autoSaverTimeOut || [];
        clearTimeout(self.autoSaverTimeOut[actionmodel]);
        if (self.GetModelByName(actionmodel) == null) return;

        const model = self.GetModelByName(actionmodel).model;
        const setupedAutosaveTimeOut = Number(model.autoSaverTimeOut);
        const mASaveTimeOut = isNaN(setupedAutosaveTimeOut) || (setupedAutosaveTimeOut < 500 && setupedAutosaveTimeOut != 0) ? 500 : setupedAutosaveTimeOut;
        if (mASaveTimeOut <= 0) return;
        self.autoSaverTimeOut[actionmodel] = setTimeout(function () {
            self.autoSaverTimeOut[actionmodel] = 0;
            var saveInProgress = self.saveInProgress;
            if (saveInProgress) return self.TriggerAutoSave(actionmodel, before, after);
            // if current record is being edited - we will not save it - only other records will be saved
            var editingUid = getEditingCellRowUid(actionmodel);
            if (editingUid) self.TriggerAutoSave(actionmodel, before, after);
            var items;
            if (!self.IsEntityToSavePresent(self.GetState(), false, itms => items = itms, false)) return;//nothing to save
            if (editingUid && !hasSavableItemsExceptEditing(actionmodel, items, editingUid)) return;//only the open record is pending
            self.saveInProgress = true;
            var steps = new $.Deferred();
            var pmKey = items.find(x => x.key.indexOf("PM.") === 0 || x.key.indexOf("popup") === 0);
            if (pmKey)
                XPortal.EditForm.StartAutoSave(pmKey.key).then(function (status) {
                    if (status !== true) return steps.resolve();
                    var currentModel = self.GetState().pageModels[pmKey.key];
                    if ((currentModel.model.IsCreating || currentModel.model.PageIsReloading) && !currentModel.model.isPopup)
                        steps.done(function () {
                            window.location.href = XPortal.EditForm.ModifyUrlAfterNewRecordSave(window.location.href);
                        });
                    return steps.resolve(status);
                })
                    .fail(() => self.saveInProgress = false)
                    .done(() => self.saveInProgress = false);
            else steps.resolve(true);
            steps.then(function (status) {
                XPortal.GridInlineEditing.StartAutoSave();
            });
            steps.fail(() => self.saveInProgress = false);
            steps.done(() => self.saveInProgress = false);

        }, mASaveTimeOut);
    };
    // data-uid of the grid row whose inline editor is open, or null (not a visible grid / no editor).
    // Lets autosave skip only the record still being edited.
    function getEditingCellRowUid(modelName) {
        const aModel = XPortal.Store.GetModelByName(modelName);
        if (!aModel || aModel.GridModel == null) return null; //it is not grid model

        const gridEl = $(aModel.model.selector);
        if (gridEl.is(":visible") == false) return null;

        const editingCell = gridEl.find(".k-edit-cell");
        if (editingCell.length === 0) return null;
        return editingCell.closest("tr").attr("data-uid") || null;
    };
    function isEntityBeingEdited(item, editingUid) {
        return !!editingUid && item.entity && item.entity.uid === editingUid;
    };
    function hasSavableItemsExceptEditing(actionmodel, items, editingUid) {
        if (!items || items.length === 0) return false;
        return items.some(function (m) {
            if (m.key !== actionmodel) return true;
            return m.items.some(function (it) { return !isEntityBeingEdited(it, editingUid); });
        });
    };
    self.Init = function () {
        //INIT store
        let middleWares = [...initEvents()];
        var redusers = Redux.combineReducers({ baseReduser: XPortal.Redusers.baseReduser, deleteReduser: XPortal.Redusers.deleteReduser, lastAction: XPortal.Redusers.lastActionReducer });
        // track when a dispatch is in progress (see IsDispatching)
        var guardedRedusers = function (state, action) {
            self.isDispatching = true;
            try {
                return redusers(state, action);
            } finally {
                self.isDispatching = false;
            }
        };
        self.AppStore = Redux.createStore(guardedRedusers, Redux.applyMiddleware(...middleWares, self.logger, self.autoSaver, self.applyRules, ReduxThunk.default));
        $(document).off("keyup.autosave");
        $(document).on("keyup.autosave", function () {
            if (!self.autoSaverTimeOut) return;
            for (var i in self.autoSaverTimeOut)
                if (self.autoSaverTimeOut[i] > 0)
                    XPortal.EditForm.ValidateModel(i, true).then(function () {
                        self.TriggerAutoSave(i);
                    });
        });
    };
    self.ForceCloseForm = function (val) {
        const st = self.GetState();
        if (val == null) return st.ForceCloseForm;
        return st.ForceCloseForm = val;
    };
    function initEvents(middleWares) {
        middleWares = middleWares ? middleWares : [];
        if (!XPortal.Event) return middleWares;
        for (var propName in XPortal.Event) {
            let eventContainer = XPortal.Event[propName];
            let relatedData = {};
            eventContainer.eventsMetadata().forEach(function (dataOptions) {
                relatedData[dataOptions.name] = function (xquery, size, pagenr, orderBy, onBeforeAjaxSend, parentInfo) {//method to return related data by query
                    var promise = new Promise(function (resolve, reject) {
                        if (!xquery && self.relatedDataSources.hasOwnProperty(dataOptions.name))
                            resolve(self.relatedDataSources[dataOptions.name]);
                        else {
                            var xrequest = Object.assign({ "Keywords": "", "Paging": { "Index": pagenr ? pagenr : 1, "Size": size ? size : 1000 }, "Sort": [{ "Name": orderBy ? orderBy : "no" }], "ParentItem": parentInfo }, xquery ? xquery : {});
                            return self.GetRelatedData({ url: self.apiBaseUrl + encodeURIComponent(dataOptions.relatedNodeId), request: xrequest }, onBeforeAjaxSend)
                                .then(function (result) {
                                    if (result && result.Data) {
                                        result.Data.map(di => XPortal.Grid.MapEntity(di));
                                        if (!xquery) self.relatedDataSources[dataOptions.name] = result.Data;
                                        resolve(result.Data);
                                    } else {
                                        if (!xquery) self.relatedDataSources[dataOptions.name] = {};
                                        reject(result);
                                    }
                                }).fail(function (result) {
                                    if (!xquery) self.relatedDataSources[dataOptions.name] = {};
                                    reject(result);
                                });
                        }
                    });
                    return promise;
                };
            });
            eventContainer.eventList().forEach(function (eventName) {
                const eventFunc = eventContainer[eventName];
                const params = propName.split("_").reverse();
                const modelId = params[0];
                const entityType = params.slice(1).reverse().join("_");
                middleWares.push(self.MiddlewareWrapper(entityType, modelId, relatedData, eventFunc, eventName));
            });
        }
        return middleWares;
    }

    //wneh we don't need autosave
    self.DispatchWithoutEvents = function (modelName, field, data, omitAutoSave, updateGrid) {
        field = field.toLowerCase();
        const forceRefreshCell = true;
        self.AppStore.dispatch({ forceRefreshCell, type: XPortal.Redusers.ACTIONS.EDIT_FIELD, field: { field, data }, model: modelName, omitAutoSave: omitAutoSave, updateGrid: updateGrid, omitEvents: true });
    };
    self.DispatchNoAutoSave = function (modelName, field, data, ftype, updateGrid) {
        field = field.toLowerCase();
        self.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.EDIT_FIELD, field: { field, data, ftype }, model: modelName, omitAutoSave: true, updateGrid: updateGrid });
    };
    // System dispatches (autofill, server events) deliver datetimes UTC-marked; convert them to the
    // member-local naive shape manual picker edits produce. Naive/date-only/other values pass through.
    self.NormalizeSystemDateTime = function (data) {
        if (XPortal.Utils.IsUtcMarkedDateTimeValue(data)) {
            var d = XPortal.Utils.AdjustDT(data, true);
            if (d instanceof Date && !isNaN(d.getTime())) return XPortal.Utils.FormatDateTimeNaive(d);
        }
        return data;
    };
  
    self.DispatchByName = function (modelName, field, data, omitAutoSave, updateGrid) {
        field = field.toLowerCase();
        data = self.NormalizeSystemDateTime(data);
        self.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.EDIT_FIELD, field: { field, data }, model: modelName, omitAutoSave, updateGrid: updateGrid });
    };
    self.DispatchByNameForEntity = function (modelName, field, data, entity, omitAutoSave, updateGrid) {
        field = field.toLowerCase();
        data = self.NormalizeSystemDateTime(data);
        self.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.EDIT_FIELD, field: { field, data }, model: modelName, entity: entity, omitAutoSave, updateGrid: updateGrid });
    };
    self.DispatchByNameRevert = function (modelName, field, data, omitAutoSave, updateGrid) {
        field = field.toLowerCase();
        self.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.EDIT_FIELD, field: { field, data }, model: modelName, omitAutoSave, updateGrid: updateGrid });
    };
    self.DispatchByNameWitUpdating = function (modelName, field, data, ftype, updateGrid) {
        field = field.toLowerCase();
        self.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.EDIT_FIELD, field: { field, data, ftype }, model: modelName, updateGrid: updateGrid });
    };
    self.DispatchFieldEditorEvent = function (element, value, modelName, omitAutoSave) {
        self.FieldEvent(element, value, modelName, null, omitAutoSave);
    };
    self.DispatchEvent = function (element, value, modelName, omitAutoSave) {
        self.FieldEvent(element, value, modelName, null, omitAutoSave);
    };
    self.FieldEvent = function (element, value, modelName, sttings, omitAutoSave, eventType = XPortal.Redusers.ACTIONS.EDIT_FIELD) {
        if (!sttings) sttings = XPortal.Main.GetSettingsFor(element);/// this should be simplified - settings should always be here
        try {
            if (!sttings.meta || !sttings.meta.fieldname) {
                if (console && console.log) console.log('FieldEvent: no meta.fieldname for', element);
                return;
            }
            var fdata = {
                field: sttings.meta.fieldname.toLowerCase(), ftype: sttings.meta.type, data: value, editor: sttings.editor, ismultiselect: sttings.ismultiselect
            };
            self.DispatchFieldEvent(eventType, fdata, modelName, omitAutoSave);
        } catch (e) {
            if (console && console.log) console.log(e);
        }
    };
    self.DispatchFieldEvent = function (eventType, fieldEventData, modelName, omitAutoSave, isDefaultEditor) {
        return self.AppStore.dispatch({ type: eventType, field: fieldEventData, model: modelName, omitAutoSave, isDefaultEditor });
    };
    self.DispatchFieldEvents = function (objToProcess, fieldNames, modelName, isdebug, isDefaultEditor, eventType = XPortal.Redusers.ACTIONS.EDIT_FIELD) {
        if (!objToProcess) return;
        for (var i = 0; i < fieldNames.length; i++) {
            var fieldEventData = {
                field: fieldNames[i].name.toLowerCase(),
                ftype: fieldNames[i].type,
                data: null
            };
            var fName = XPortal.Template.GetObjPropName(objToProcess, fieldEventData.field);
            if (fName && (fieldEventData.data = objToProcess[fName])) {
                try {
                    self.DispatchFieldEvent(eventType, fieldEventData, modelName, true, isDefaultEditor);
                } catch (e) {
                    if (console && console.log) console.log(e);
                }
            }
        }

        if ((isdebug || self.debug) && console && console.log) console.log("dispaching object events:" + modelName, objToProcess, fieldNames, eventType);
    };
    self.DispatchForOtherEntity = function (modelName, entity, dataFields, dispatchAnyWay, beforeChageModelEntity, saveChanges, updateGrid) {
        updateGrid = updateGrid ? true : false;
        var changes = 0;
        let srcEntityInState = null;
        if (dataFields && dataFields.length > 0) {
            dataFields.forEach(x => {
                if (x != null && x.name) {
                    var model = XPortal.Store.GetModelByName(modelName);
                    // temporary bind entity to state if current is different
                    if (!model.entity || model.entity.UniqueId != entity.UniqueId) {
                        srcEntityInState = model.entity;
                        if (beforeChageModelEntity) beforeChageModelEntity(model.entity, x.name, x.value, entity);
                        XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.BIND_ENTITY, modelName: modelName, entity: entity });
                    }
                    if (dispatchAnyWay) {
                        const fieldName = x.name.toLowerCase();
                        const forceRefreshCell = true;// !!(modelName?.includes("GM") && srcEntityInState);
                        const entityToSave = srcEntityInState ? entity : null;
                        if (!saveChanges) self.AppStore.dispatch({ forceRefreshCell, type: XPortal.Redusers.ACTIONS.EDIT_FIELD, field: { field: fieldName, data: x.value }, model: modelName, entity: entityToSave, omitAutoSave: true, updateGrid });
                        else self.AppStore.dispatch({ forceRefreshCell, type: XPortal.Redusers.ACTIONS.EDIT_FIELD, field: { field: fieldName, data: x.value }, model: modelName, entity: entityToSave, updateGrid });
                        changes++;
                    }
                    else {
                        var action = !saveChanges ? XPortal.Events.helpers.dispatchNoAutoSaveIfChanged : XPortal.Events.helpers.dispatchByNameIfChanged;
                        if (action(modelName, x.name, x.value, saveChanges)) changes++;
                    }
                }
            });
        }
        // rebind previous entity after dispatching if it was changed
        if (srcEntityInState != null)
            XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.BIND_ENTITY, modelName: modelName, entity: srcEntityInState });
        return changes > 0;
    };
    self.DispatchDisplayValue = function (element, displayValue, modelName, sttings) {//in case when we have to show something else
        if (!sttings) sttings = XPortal.Main.GetSettingsFor(element);
        try {
            var fdata = { field: sttings.meta.fieldname.toLowerCase() + "___Value___", ftype: sttings.meta.type, data: displayValue, editor: sttings.editor, ismultiselect: sttings.ismultiselect };
            self.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.EDIT_DISPLAYFIELD, field: fdata, model: modelName, omitAutoSave: true, isDefaultEditor: false });
        } catch (e) {
            if (console && console.log) console.log(e);
        }
    }

    //Base implementation of property subscriber
    // Controls can obtain changes by direct call of AppStore.Subscribe and property values check
    self.Subscribe = function (params, callback, onLatestValue) {
        if (!params.Field) {
            console.warn("Subscribe params.Field is undefined. Maybe field is hidden or not on view.");
            return;
        }
        var state = self.GetBaseReduserState();
        var xentity = (state.pageModels[params.Model] || {}).entity;
        var uniqueId = xentity ? xentity.UniqueId : null;
        if (!uniqueId) console.warn("During control subscribe process 'entity' is not available.");


        var modelName = params.Model;
        var propName = params.Field.toLowerCase();
        var valueControl = params.Target;
        if (!callback) return;
        self.subscriptions = self.subscriptions || [];
        var subscrId = self.subscriptions.findIndex(s => s.modelName === modelName && s.propName === propName);
        if (subscrId > -1) { // we already have subscription for this field
            //it is normal in case of detail form (2 same fields), but in case of grid we have onlu 1 active editor
            //so if modelName is grid model we insubscribe previous editor and remove subscription
            subscr = self.subscriptions[subscrId];
            if (modelName.startsWith("GM.")) {
                subscr.unsubscribe();
                self.subscriptions.splice(subscrId, 1);
            }
        } //already subscribed
        var unsubscribe = self.AppStore.subscribe(() => {
            var laction = self.AppStore.getState().lastAction;

            var state = self.GetBaseReduserState();
            if (!state.pageModels || !valueControl) return;
            if (!laction.field) return;
            if (!laction.field.field || laction.field.field.toLowerCase() !== propName.toLowerCase()) return;
            try {
                if (!state.pageModels.hasOwnProperty(modelName)) return;
                var xentity = state.pageModels[modelName].entity;
                if (!xentity || !xentity.hasOwnProperty(propName)) return;
                if (uniqueId !== xentity.UniqueId) return;

                var xpropvalue = xentity[propName];
                var field = xentity.Fields.find(f => f.Name.toLowerCase() === propName);
                if (field && field.ismultiselect && field.StringValue && field.StringValue.join)
                    xpropvalue = field.StringValue.join(XPortal.GridInlineEditing.ValueSeparator);

                var currentControlValue = onLatestValue ? onLatestValue(xpropvalue, laction.field) : valueControl.value ? valueControl.value() : valueControl.val(); //Additional check's ? 

                if (xpropvalue !== currentControlValue) {
                    //console.log("propName [" + propName + "]>" + currentControlValue + ">" + xpropvalue, modelName, laction);
                    callback(xpropvalue);
                    valueControl.trigger('editformcontrol');
                }
            }
            catch (e) {
                if (console) console.error("problem with controls subscriptions processing", e);
            }
        });
        self.subscriptions.push({ modelName, propName, valueControl, unsubscribe });
    };
    self.RemoveControlSubscription = function (modelName, propName, uniqueId) {
        self.subscriptions = self.subscriptions || [];
        var subscrId = self.subscriptions.findIndex(s => s.modelName === modelName && s.propName === propName);
        if (subscrId > -1) { // we already have subscription for this field
            //it is normal in case of detail form (2 same fields), but in case of grid we have onlu 1 active editor
            //so if modelName is grid model we insubscribe previous editor and remove subscription
            subscr = self.subscriptions[subscrId];
            subscr.unsubscribe();
            self.subscriptions.splice(subscrId, 1);
        }
        return subscrId;
    };
    self.GetRelatedData = function (params, onBeforeAjaxSend) {
        if (!params.url) throw ("loading url is not defined");
        if ((params.request["Filter"] || params.request["filter"]) && !((params.request["Filters"] || params.request["filters"])))//backward compatibility
            params.request["Filters"] = [params.request["Filter"] || params.request["filter"]];
        var d = $.Deferred();
        var ajaxOpts = {
            method: "POST", url: XPortal.Utils.EnsureInProfile(params.url), dataType: "json", contentType: "application/json; charset=utf-8", data: JSON.stringify(params.request), cache: false,
            headers: { "RequestVerificationToken": XPortal.Main.getAntiForgeryToken() },
            success: function (xdata) {
                d.resolve(xdata);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                if (console) console.log("error get related data:" + JSON.stringify(params), jqXHR, textStatus, errorThrown);
                d.reject(jqXHR);
            }
        };
        if (onBeforeAjaxSend) ajaxOpts = onBeforeAjaxSend(ajaxOpts);
        jQuery.ajax(ajaxOpts)
            .then(function (xdata) {
                d.resolve(xdata);
            })
            .fail(function (problem) {
                d.reject(problem);
            });
        return d.promise();
    };
    self.AddEntity = function (nodeId, data) {
        var url = "/api/2.0/Entities/Create/" + nodeId;
        var d = $.Deferred();
        jQuery.ajax({
            method: "PUT",
            headers: {
                "Accept": "application/json",
                "client_id": "testclient",
                "RequestVerificationToken": XPortal.Main.getAntiForgeryToken()
            },
            url: XPortal.Utils.EnsureInProfile(url),
            dataType: "json",
            data: data,
            success: function (xdata) { d.resolve(xdata); },
            error: function (jqXHR, textStatus, errorThrown) {
                if (console) console.log("error delete related data:" + JSON.stringify(params), jqXHR, textStatus, errorThrown);
                d.reject(jqXHR);
            }
        })
            .then(function (xdata) { d.resolve(xdata); })
            .fail(function (problem) { d.reject(problem); });
        return d.promise();
    };

    self.UpdateEntity = function (nodeId, data) {
        var url = "/api/2.0/Entities/Update/" + nodeId;
        var d = $.Deferred();
        jQuery.ajax({
            method: "POST",
            headers: {
                "Accept": "application/json",
                "client_id": "wbiclient",
                "Content-Type": "application/json",
                "RequestVerificationToken": XPortal.Main.getAntiForgeryToken()
            },
            url: XPortal.Utils.EnsureInProfile(url),
            dataType: "json",
            data: data,
            success: function (xdata) { d.resolve(xdata); },
            error: function (jqXHR, textStatus, errorThrown) {
                if (console) console.log("error delete related data:" + JSON.stringify(params), jqXHR, textStatus, errorThrown);
                d.reject(jqXHR);
            }
        })
            .then(function (xdata) { d.resolve(xdata); })
            .fail(function (problem) { d.reject(problem); });
        return d.promise();
    };

    self.UpdateEntities = function (nodeId, dataArray) {
        var url = "/api/2.0/Entities/UpdateArray/" + nodeId;
        var d = $.Deferred();
        var data = {
            Array: dataArray
        };
        jQuery.ajax({
            method: "POST",
            headers: {
                "Accept": "application/json",
                "client_id": "testclient",
                "RequestVerificationToken": XPortal.Main.getAntiForgeryToken()
            },
            url: XPortal.Utils.EnsureInProfile(url),
            dataType: "json",
            data: data,
            success: function (xdata) { d.resolve(xdata); },
            error: function (jqXHR, textStatus, errorThrown) {
                if (console) console.log("error delete related data:" + JSON.stringify(params), jqXHR, textStatus, errorThrown);
                d.reject(jqXHR);
            }
        })
            .then(function (xdata) { d.resolve(xdata); })
            .fail(function (problem) { d.reject(problem); });
        return d.promise();
    };

    self.IsAnyFieldsEditable = function (modelName, ...fieldNames) {
        if (!fieldNames || !fieldNames.length) return true;
        const smodel = self.GetModelByName(modelName);
        if (!smodel || !smodel.model) return true;
        if (smodel.model.Fields && smodel.model.Fields.length) {
            const efnames = smodel.model.Fields.filter(x => x.editable).map(x => x.Name);
            const exists = efnames.find(x => _.contains(fieldNames, (x || "").toLowerCase()));
            if (exists) return true;
        }
        if (smodel.GridModel && smodel.GridModel.columns) {
            const efnames = smodel.GridModel.columns.filter(x => x.canedit).map(x => x.field);
            const exists = efnames.find(x => _.contains(fieldNames, (x || "").toLowerCase()));
            if (exists) return true;
        }
        return false;
    };

    self.RelatedDataByQuery = function (xquery, relatedNodeId, size) {
        var promise = new Promise(function (resolve, reject) {
            var xrequest = Object.assign({ "Keywords": "", "Paging": { "Index": 1, "Size": size ? size : 10 }, "Sort": [{ "Name": "no" }] }, xquery ? xquery : {});
            return self.GetRelatedData({ url: self.apiBaseUrl + encodeURIComponent(relatedNodeId), request: xrequest })
                .then(function (result) {
                    if (result && result.Data) {
                        result.Data.map(di => XPortal.Grid.MapEntity(di));
                        resolve(result.Data);
                    } else {
                        reject(result);
                    }
                }).fail(function (result) {
                    reject(result);
                });
        });
        return promise;
    };

    self.RefreshItemsForModel = function (modelName) {
        var modelByName = XPortal.Store.GetModelByName(modelName);
        var itms = modelByName.itemsToRefresh || [];
        modelByName.itemsToRefresh = [];
        itms.forEach((x, xi) => {
            var uid = XPortal.Template.GetObjPropValueByName(x, "uniqueid");
            for (var i in x)
                if (i.toLowerCase() != "uniqueid") {
                    modelByName = XPortal.Store.GetModelByName(modelName);
                    if (uid == XPortal.Template.GetObjPropValueByName(modelByName.entity, "uniqueid"))
                        self.DispatchFieldEvent(XPortal.Redusers.ACTIONS.NOTIFY_EDITED, { field: i.toLowerCase(), data: x[i] }, modelName, true);
                }
        });
    };
    /*---start event state processing -------------*/
    self.StartEventProcessing = function (eventName, entityId, actionType, action) {
        var eventIndex = selfData.eventsInProgress.findIndex(function (ei, ix) {
            return ei.id == eventName;
        });
        if (eventIndex === -1) {
            selfData.eventsInProgress.push({ id: eventName, date: Date.now(), entityId: entityId, actionType: actionType, });
            eventIndex = selfData.eventsInProgress.findIndex(function (ei, ix) { return ei.id == eventName; });
        }
        self.TriggerEventStateChanged(eventIndex, eventName, entityId, actionType);
    };
    self.FinishEventProcessing = function (eventName, entityId, actionType, action) {
        var eventIndex = selfData.eventsInProgress.findIndex(function (ei, ix) {
            return ei.id == eventName;
        });
        if (eventIndex > -1) selfData.eventsInProgress.splice(eventIndex, 1);
        self.TriggerEventStateChanged(-1, eventName, entityId, actionType);

    };
    self.TriggerEventStateChanged = function (eindex, ename, eid, actionType) {
        if (selfData.eventStateHandlers.length < 1) return;
        var ievent = eindex > -1 ? selfData.eventsInProgress[eindex] : null;
        let eothers = selfData.eventsInProgress.filter(function (ei, ix) { return ei.entityId === eid; });
        selfData.eventStateHandlers.forEach(async function (esi, ix) {
            if (typeof (esi.callback) === "function")
                try {
                    await esi.callback({ entityId: eid, action: actionType, others: eothers, current: ievent }, selfData.eventsInProgress);
                } catch (e) {
                    if (console && console.log) console.log("Error: can't execute event state handler." + ename, e);
                }
        });
    };
    self.AddRemoveEventStatesHandler = async function (handlerUniqueId, isAdd, onStateChanged) {
        var eix = selfData.eventStateHandlers.findIndex(function (esi, ix) {
            return esi.id == handlerUniqueId;
        });
        if (eix !== -1) selfData.eventStateHandlers.splice(eix, 1);
        if (isAdd) selfData.eventStateHandlers.push({ id: handlerUniqueId, callback: onStateChanged });
    };
    self.ProcessEntitiesSynchronously = async function (onNext, isEventsAreDone, hndlruniqId) {
        var result = [];
        hndlruniqId = hndlruniqId ? hndlruniqId : "hndr-1";
        /// 3 - wait for each event completed with this record
        var waitForEventsToComplet = async function (xitem) {
            self.AddRemoveEventStatesHandler(hndlruniqId, false);
            return await new Promise(function (res, rej) {
                try {
                    var isdone = isEventsAreDone(state, eventsInprogress, res);
                    if (isdone) return res({ entityId: xitem.uniqueId, action: "", working: 0 });
                } catch (e) {
                    return rej(e);
                }
                self.AddRemoveEventStatesHandler(hndlruniqId, true, async function (state, eventsInprogress) {
                    try {
                        var isdone = await isEventsAreDone(state, eventsInprogress, res);
                        if (isdone) return res({ entityId: state.entityId, action: state.action, working: state.others.length });
                    } catch (e) {
                        self.AddRemoveEventStatesHandler(hndlruniqId, false);
                        rej(e);
                    }
                });
            });
        };
        /// 2 - process one iteration item
        var executeNextItem = async function () {
            var item = await onNext();
            if (item == null) return false;
            try {
                var evtr = await waitForEventsToComplet(item);
                result.push({ item: item, processed: true, result: evtr });
            } catch (e) {
                result.push({ item: item, processed: false, error: e });
            }
            return true;
        };
        /// 1 - process items synchronously
        let i = 0;
        while (await executeNextItem()) i++;
        return result;
    };
    //XPortal.Store.Test1CheckAddEvntStateHdl();
    self.Test1CheckAddEvntStateHdl = function () {
        ///1- this test just check that events state is working properly
        self.AddRemoveEventStatesHandler("test1", false);
        self.AddRemoveEventStatesHandler("test1", true, function (state, eventsInprogress) {
            try {
                if (state.others.length < 1) {
                    setTimeout(function () {
                        if (!self.HasInProgressEvents()) self.AddRemoveEventStatesHandler("test1", false);
                    }, 5000);
                }
            } catch (e) {
            }
        });
    };
    self.Test2CheckEntitiesProcessingSync = function (gridId) {
        var grid = $("#entity-grid-22828");// for page: /en-us/eventstate-tests/#22828/v/All
        var kgrid = grid.data("kendoGrid");
        var entities = kgrid._data;//existing grid data - page         
        var gridModelName = XPortal.Store.getGridModelName(grid.attr("id"));
        var nodeId = kgrid.options.pageData.nodeId;


        var item = null;
        var waitinterval = -1;
        XPortal.Store.ProcessEntitiesSynchronously(
            async function () {//                                       1 -get next item
                item = entities.length > 0 ? entities.pop() : null;
                entities = entities.filter(function (ei, ix) { return ei.UniqueId !== item.UniqueId; });
                console.log("item, entities:" + entities.length);
                return await new Promise((r) => {
                    if (item != null) {
                        //code that has to be executed for collection
                        XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.BIND_ENTITY, modelName: gridModelName, entity: item, model: { Alias: item.EntityAlias, NodeId: nodeId } });
                        setTimeout(function () {
                            var curvalue = item["buyercontactdescription"];//get current value from one field and change it automatically to other- with prefix "-auto"                       
                            XPortal.Store.DispatchNoAutoSave(gridModelName, "buyercontactdescription", curvalue ? "-auto-" + curvalue : "-auto-");
                        }, 1000);
                    };
                    r(item);
                });
            },
            async function (state, events, ipromise) {//                2 -is it processed? - executed by event handler
                clearTimeout(waitinterval);
                var itemUniqueId = item.UniqueId;
                var r = events.length < 1;
                if (!r) {//-- check that it is completed by interval
                    console.log("there are events, that not yet completed (" + events.length + "):" + itemUniqueId);
                    var waitForData = function () {
                        var itemsCount = 0;
                        r = XPortal.Store.HasInProgressEvents(function (events) {
                            itemsCount = events.filter(function (ei, ix) { return ei.entityId === itemUniqueId; }).length;
                            return itemsCount < 1;
                        });
                        if (r)
                            ipromise();
                        else {
                            waitinterval = setTimeout(waitForData, 2500);
                            console.log("waiting 2.5sec to complete events (" + itemsCount + "):" + itemUniqueId);
                        }
                    };
                    waitinterval = setTimeout(waitForData, 2500);
                }
                return r;//return direct result
            },
            "test2");
    };


    self.howToUseIt = function () {
        var entities = [];
        self.ProcessEntitiesSynchronously(
            async function () {
                var item = entities.length > 0 ? entities.pop() : null;
                return await new Promise((r) => r(item));
            },
            async function (state, events) {
                return state == null || state.others == null || state.others.length < 1;
            }
        );
    }
    /*---end event state processing -------------*/
    return self;
}());